// src/api/hooks/useRiskStatus.js — CANON v8.7.1
//
// risk_status в реальной БД — два возможных формата:
//   Seed-формат:  'low' / 'medium' / 'high' / 'critical'
//   Live-формат:  'green' / 'yellow' / 'red'  (risk_engine.js cron)
//
// normalizeStatus() приводит оба формата к UI-значениям:
//   low/green   → 'low'
//   medium/yellow → 'medium'
//   high/red    → 'high'
//   critical    → 'critical'
//
// /api/risk/history → { ok, items: [...] }

import { useEffect, useState } from "react";
import { workerClient } from "../workerClient";

function normalizeStatus(raw) {
  switch (raw) {
    case "low":      case "green":  return "low";
    case "medium":   case "yellow": return "medium";
    case "high":     case "red":    return "high";
    case "critical":                return "critical";
    default:                        return "unknown";
  }
}

function isCrisisStatus(raw) {
  return raw === "critical" || raw === "high" || raw === "red";
}

export function useRiskStatus() {
  const [data, setData] = useState({
    riskStatus:    "unknown",  // нормализованный для UI
    riskStatusRaw: "unknown",  // как в БД
    riskScore:     null,
    lastRiskEvent: null,
    engineOnline:  true,
    loading:       true,
    error:         false,
  });

  useEffect(() => {
    let mounted = true;

    async function load() {
      try {
        const [statusRes, historyRes] = await Promise.all([
          workerClient("/api/risk/status"),
          workerClient("/api/risk/history"),
        ]);

        if (!mounted) return;

        // /api/risk/history → { ok, items: [...] }
        const history = Array.isArray(historyRes?.items) ? historyRes.items : [];

        const lastCrisis = history
          .filter(e => isCrisisStatus(e.risk_status))
          .sort((a, b) => (b.date ?? "").localeCompare(a.date ?? ""))[0] ?? null;

        const rawStatus = statusRes?.risk_status ?? "unknown";

        setData({
          riskStatus:    normalizeStatus(rawStatus),
          riskStatusRaw: rawStatus,
          riskScore:     statusRes?.risk_score ?? null,
          lastRiskEvent: lastCrisis,
          engineOnline:  true,
          loading:       false,
          error:         false,
        });
      } catch {
        if (!mounted) return;
        setData({ riskStatus: "unknown", riskStatusRaw: "unknown", riskScore: null,
                  lastRiskEvent: null, engineOnline: false, loading: false, error: true });
      }
    }

    load();
    return () => { mounted = false; };
  }, []);

  return data;
}
